import React from "react";

const WelcomeIntro = () => {
  const getOpenTime = () => new Date().getFullYear() - 2002;

  return (
    <React.Fragment>
      <span className="eyebrow">Welcome</span>
      <h1>Exceptional Dentistry, Close to Home</h1>
      <p>
        For nearly {getOpenTime()} years, Dr. Marcus Bellamy, DMD, and his team
        have provided exceptional restorative and cosmetic dental care to the
        community of Monument, CO and the surrounding areas.
      </p>
      <p>
        The team at Monument Dental is committed to caring for teens and adults.
        From basic preventative care to the most complex cosmetic procedures,
        Dr. Bellamy has become one of the preferred providers in the Monument
        area.
      </p>
      <p>
        Dr. Bellamy has extensive experience in general and cosmetic dentistry
        and maintains state-of-the-art dental equipment right in his office.
        Patients appreciate the fast, pain-free procedures offered at Monument
        Dental. As a family-oriented practice, we offer a wide variety of
        restorative and cosmetic services, including dental implants, veneers,
        crowns, root canals, extractions and more.
      </p>
      <p>
        Through ongoing continuing education, Dr. Bellamy ensures that his
        patients always receive the most cutting-edge treatments possible.
      </p>
    </React.Fragment>
  );
};

export default WelcomeIntro;
